// src/icons/Selector.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function Selector({
  strokeWidth = "1.5",
  strokeLinecap = "round",
  strokeLinejoin = "round"
}) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M4 5.33331L8 1.33331L12 5.33331",
            stroke: "currentColor",
            strokeWidth,
            strokeLinecap,
            strokeLinejoin
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M4 10.6667L8 14.6667L12 10.6667",
            stroke: "currentColor",
            strokeWidth,
            strokeLinecap,
            strokeLinejoin
          }
        )
      ]
    }
  );
}

export {
  Selector
};
